
window.addEventListener("DOMContentLoaded", () => {
  const caseStudies = gsap.utils.toArray(".case-studies");
  const requirements = gsap.utils.toArray(".requirements-section");

  gsap.utils.toArray(".showcase-new").forEach((section) => {
    const elements = section.querySelectorAll(".animate-fade-in-showcase");

    gsap.from(elements, {
      scrollTrigger: {
        trigger: section,
        start: "top 60%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 20,
      duration: 1.3,
      ease: "power3.out",
    });
  });

  caseStudies.forEach((section) => {
    const first = section.querySelectorAll(".case-studies .first");
    const second = section.querySelectorAll(".case-studies .second");
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      defaults: {
        duration: 1.3,
        ease: "power3.out",
      },
    });

    tl.from(first, {
      opacity: 0,
      y: 20,
      duration: 1.3,
      ease: "power3.out",
    }).from(
      second,
      {
        opacity: 0,
        y: 20,

        ease: "power3.out",
      },

      "<+=0.5"
    );
  });

  requirements.forEach((section) => {
    const first = section.querySelectorAll(".requirements-section .first");
    const second = section.querySelectorAll(".requirements-section .second");
    const third = section.querySelectorAll(".requirements-section .third");
    const fourth = section.querySelectorAll(".requirements-section .fourth");

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      defaults: {
        duration: 1.3,
        ease: "power3.out",
      },
    });

    tl.from(first, {
      opacity: 0,
      y: 20,
      ease: "power3.out",
    })
      .from(
        second,
        {
          opacity: 0,
          y: 20,
          ease: "power3.out",
        },
        "<+=0.5"
      )
      .from(
        third,
        {
          opacity: 0,
          y: 20,
          ease: "power3.out",
        },
        "<+=0.5"
      )
      .from(
        fourth,
        {
          opacity: 0,
          y: 20,
          ease: "power3.out",
        },
        "<+=0.5"
      );
  });
  gsap.utils.toArray(".testimonials-section").forEach((section) => {
    const elements = section.querySelectorAll(".testimonials-fade-in");
    gsap.from(elements, {
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 20,
      duration: 1.3,
      ease: "power3.out",
    });
  });

  gsap.utils.toArray(".faq-section").forEach((section) => {
    const elements = section.querySelectorAll(".faq-fade-in");
    gsap.from(elements, {
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 20,
      duration: 1.3,
      ease: "power3.out",
    });
  });
});

gsap.utils.toArray(".articles-section").forEach((section) => {
  const cards = section.querySelectorAll(".article-card");
  if (!cards.length) return;

  gsap.set(cards, {
    opacity: 0,
    y: 10,
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 70%",
      toggleActions: "play none none none",
    },
    defaults: {
      duration: 1.3,
      ease: "power3.out",
    },
  });

  const cardSets = [];
  for (let i = 0; i < cards.length; i += 3) {
    cardSets.push(Array.from(cards).slice(i, i + 3));
  }

  cardSets.forEach((set, index) => {
    tl.to(
      set,
      {
        opacity: 1,
        y: 0,
        ease: "power3.out",
      },
      index * 0.6
    );
  });

  const footer = gsap.utils.toArray(".footer-new");
  footer.forEach((section) => {
    const first = section.querySelector(".footer-new .first");
    const second = section.querySelector(".footer-new .second");

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      defaults: {
        duration: 1.3,
        ease: "power3.out",
      },
    });
    tl.from(first, {
      opacity: 0,
      y: 20,
      ease: "power3.out",
    }).from(second, {
        opacity: 0,
        y: 20,
        ease: "power3.out",
      },
      "<+=0.5"
    );
  });
});
